import styled from 'styled-components';
import { BorderTop } from '../../../../../src/styled/shared-styles';
import { getSizeBy } from '../../../../../src/styled/utils';
export const StyledTableTop = styled.div `
  ${BorderTop};
  padding: ${getSizeBy(4)} ${getSizeBy(4)};
`;
